module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel03_1280_1280_ja-fc5f31d3d7e5d129e59fe1222bbd9340.jpg";